import { render, staticRenderFns } from "./CommoditiesMulti.vue?vue&type=template&id=0e331dfc&"
import script from "./CommoditiesMulti.vue?vue&type=script&lang=js&"
export * from "./CommoditiesMulti.vue?vue&type=script&lang=js&"
import style0 from "./CommoditiesMulti.vue?vue&type=style&index=0&id=0e331dfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports